module.exports = __webpack_public_path__ + "static/media/triobanner.f0f3c40f.png";